import * as React from "react";

const MOBILE_BREAKPOINT = 768;
const MOBILE_QUERY = `(max-width: ${MOBILE_BREAKPOINT - 1}px)`;

const subscribe = (onChange: () => void) => {
  const mql = window.matchMedia(MOBILE_QUERY);
  mql.addEventListener("change", onChange);
  return () => mql.removeEventListener("change", onChange);
};

/**
 * 모바일 폭인지.
 *
 * matchMedia 는 React 밖의 상태이므로 useSyncExternalStore 로 읽는다 —
 * effect 에서 setState 로 옮기면 첫 렌더가 항상 데스크톱으로 그려진 뒤 한 번 더 돈다.
 */
export function useIsMobile() {
  return React.useSyncExternalStore(
    subscribe,
    () => window.matchMedia(MOBILE_QUERY).matches,
    // SSR 은 쓰지 않지만 서버 스냅샷은 필수 인자다 — 데스크톱으로 본다
    () => false,
  );
}
